export default __webpack_public_path__ + "static/media/create.42ce8c96.svg";